import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { AssessmentFlow } from './components/AssessmentFlow';
import ResultsPage from './components/ResultsPage';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header className="App-header">
          <h1>Coachoria Assessment Platform</h1>
          <p>AI-Powered Personal Development Assessment</p>
        </header>
        <main>
          <Routes>
            <Route path="/" element={<AssessmentFlow />} />
            <Route path="/vysledky/:token" element={<ResultsPage />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
